import { render, staticRenderFns } from "./IosAddToHomePopup.vue?vue&type=template&id=29a56721&scoped=true&"
import script from "./IosAddToHomePopup.vue?vue&type=script&lang=js&"
export * from "./IosAddToHomePopup.vue?vue&type=script&lang=js&"
import style0 from "./IosAddToHomePopup.vue?vue&type=style&index=0&id=29a56721&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a56721",
  null
  
)

export default component.exports